import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';
import { useState } from 'react';
import Badge from '@mui/material/Badge';
import MailIcon from '@mui/icons-material/Mail';
import RequestAQuoteModal from '@Components/Shared/Modals/RequestAQuoteModal.jsx';
import RequestACharterModal from '@Components/Shared/Modals/RequestACharterModal.jsx';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import EditIcon from '@mui/icons-material/Edit';
import { CharterFlightType } from '@Components/Utilities/SandhillsConstants';

const QuoteRequest = (props) => {
    const quoteInfo = (label, value) => {
        if (label && value) {
            return (
                <div>
                    {value && (value + '').trim() != '' &&
                        <span className='wtb-entry-info'>
                            <strong>{label}: </strong>
                            {value}
                        </span>}
                </div>
            );
        } else {
            return (<></>);
        }
    };
    const [isEdit, setIsEdit] = useState(false);
    const [isCopy, setIsCopy] = useState(false);
    const [quoteRequest, setQuoteRequest] = useState(props);
    const [showRequestAQuoteModal, setShowRequestAQuoteModal] = useState(props.ShowRequestAQuoteModalOnLoad);
    const onCopy = () => {
        setIsCopy(true);
        onRequestAQuoteModalToggle();
    };
    const onEdit = () => {
        setIsEdit(true);
        onRequestAQuoteModalToggle();
    };
    const onRequestAQuoteModalToggle = () => {
        setShowRequestAQuoteModal(showRequestAQuoteModal => !showRequestAQuoteModal);
    };

    return (
        <div className='quote-request-div'>
            <div className='quote-request'>
                {showRequestAQuoteModal && (quoteRequest.RequestACharterModel ?
                    <RequestACharterModal
                        {...quoteRequest.RequestACharterModel}
                        toggleModal={onRequestAQuoteModalToggle}
                        showRequestAQuoteModal={showRequestAQuoteModal}
                        Copy={isCopy}
                        Edit={isEdit}
                        setQuoteRequest={setQuoteRequest}
                    />
                    :
                    <RequestAQuoteModal
                        {...quoteRequest.RequestAQuoteModel}
                        toggleModal={onRequestAQuoteModalToggle}
                        showRequestAQuoteModal={showRequestAQuoteModal}
                        Copy={isCopy}
                        Edit={isEdit}
                        setQuoteRequest={setQuoteRequest}
                    />
                )
                }
                <div className='quote-request-top'>
                    {quoteRequest.ImageURL &&
                        <div className='quote-request-image'>
                            <img tabIndex='0' src={quoteRequest.ImageURL} className={'listing-main-image'} alt={quoteRequest.CategoryFullName + " Image"} />
                        </div>}
                    <div className='quote-request-info'>
                        {quoteRequest.ListingURL ?
                            <a href={quoteRequest.ListingURL} aria-label={translator.translate('sandhills.crm.dealerservices.reports.viewlisting')}>
                                <h3>{quoteRequest.CategoryFullName}</h3>
                            </a> :
                            <h3>{quoteRequest.CategoryFullName}</h3>
                        }
                        {(quoteRequest.Manufacturer || quoteRequest.Model) &&
                            <h4>{quoteRequest.Manufacturer} {quoteRequest.Model}</h4>}
                        {quoteInfo('Request Number', quoteRequest.EquipmentMessageID)}
                        <br></br>
                        {quoteInfo(<TranslationText tKey='sandhills.quantity' />, quoteRequest.Quantity)}
                        {quoteInfo(<TranslationText tKey='sandhills.typeofaircraft' />, quoteRequest.TypeOfAircraft)}
                        {quoteInfo(<TranslationText tKey='sandhills.typeofflight' />, quoteRequest.TypeOfFlight)}
                        {quoteInfo(<TranslationText tKey='sandhills.Passengers' />, quoteRequest.NumberOfPassengers)}
                        {quoteInfo(<TranslationText tKey='sandhills.tradesites.mvc.cityairportfrom' />, quoteRequest.DepartureLocation)}
                        {quoteInfo(<TranslationText tKey='sandhills.tradesites.mvc.cityairportto' />, quoteRequest.ReturningLocation)}
                        {quoteInfo(<TranslationText tKey='sandhills.DateFrom' />, quoteRequest.DepartureDate)}
                        {quoteRequest.TypeOfFlight != CharterFlightType.OneWay && quoteInfo(<TranslationText tKey='sandhills.DateTo' />, quoteRequest.ReturnDate)}
                        {quoteInfo(<TranslationText tKey='sandhills.rentaldate' />, quoteRequest.RentalDates)}
                        {quoteInfo(<TranslationText tKey='sandhills.location' />, quoteRequest.Location)}
                        {quoteInfo(<TranslationText tKey='sandhills.tradepubwebsite.mvc.comments' />, quoteRequest.Comment)}

                    </div>
                    <div className='quote-request-buttons'>
                        {!quoteRequest.IsAccepted &&
                            <Button color="primary" variant="contained" startIcon={<EditIcon />} onClick={onEdit} className='buy-now btn btn-primary'><span><TranslationText tKey='sandhills.edit' /></span></Button>}
                        {!quoteRequest.IsAccepted &&
                            <Button color="primary" variant="contained" startIcon={<DeleteIcon />} onClick={quoteRequest.onDelete} className='buy-now btn btn-primary'><span><TranslationText tKey='sandhills.delete' /></span></Button>}
                        {quoteRequest.IsAccepted &&
                            <Button color="primary" variant="contained" startIcon={<ContentCopyIcon />} onClick={onCopy} className='buy-now btn btn-primary'><span><TranslationText tKey='sandhills.tradepubwebsite.mvc.copy' /></span></Button>}
                        {quoteRequest.QuoteCount > 0 &&
                            <Button color="primary" variant="contained" href={quoteRequest.ViewQuotesURL} className='buy-now btn btn-primary'>
                                <Box sx={{ marginRight: '8px', fontSize: '12px' }}>
                                    <Badge badgeContent={quoteRequest.NewQuoteCount} color="action">
                                        <MailIcon color="secondary" />
                                    </Badge>
                                </Box>
                                <span><TranslationText tKey='sandhills.viewquotes' /> ({quoteRequest.QuoteCount})</span>
                            </Button>}
                        {quoteRequest.MessageCount > 0 &&
                            <Button color="primary" variant="contained" href={quoteRequest.ViewAllMessagesURL} className='buy-now btn btn-primary'>
                                <Box sx={{ marginRight: '8px', fontSize: '12px' }}>
                                    <Badge badgeContent={quoteRequest.NewQuoteCount} color="action">
                                        <MailIcon color="secondary" />
                                    </Badge>
                                </Box>
                                <span><TranslationText tKey='sandhills.viewmessages' /> ({quoteRequest.MessageCount})</span>
                            </Button>}
                    </div>
                </div>
                <div className='quote-request-bottom'>
                    <span className='updated-time'><strong><TranslationText tKey='sandhills.updated' />:</strong> {quoteRequest.UpdatedDateTime}</span>
                </div>
            </div>
        </div>);
};

export default QuoteRequest;